<script>
import PropertySelection from "../propertySelection.vue";
import FooterSection from "../../package/footerSection.vue";
import PropertyIconSet from "../../package/propertyIconSet.vue";
import BreadcrumbSection from "../../package/breadcrumbSection.vue";
import AdvertisementSection from "../advertisementSection.vue";
import ConfirmationSelection from "../confirmationSelection.vue";
import DrawerAside from "../../package/DrawerAside.vue";
import HeaderSection from "../../package/HeaderSection.vue";

export default {
  name: "confirmationLayout",
  components: {
    HeaderSection,
    ConfirmationSelection,
    AdvertisementSection,
    BreadcrumbSection,
    PropertyIconSet,
    FooterSection,
    PropertySelection,
    DrawerAside
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Congratulations";
  },
  created() {
    document.title = "UNIFI Property: Congratulations";
  },
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    },
    redirectToHome() {
      this.$router.push({ path: "/homepage" });
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <!--      <drawer-aside :unfold="unfold"/>-->
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <!-- <breadcrumb-section/> -->
        <confirmation-selection />
        <property-icon-set />
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}

.main-menu-item-style {
  padding: 30px 40px;
  background-color: #101010;
  border-bottom: 1px solid #585858;
}

.menu-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #2d2d2d;
  //background-color: #2D2D2D;
}

.sub-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0 20px 40px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

.light-dark-text {
  color: #dedede;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  //color: #2D2D2D;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/confirm/confirmationLayout.vue